import {$, w} from './constants';
import { renderPDFThumbnail, viewerPDF } from './pdf.js';

let firstHomeLoad = true;
let firstCompanyLoad = true;

$(function () {
    const $gridHome = $('#grid_documents_research');
	const $gridCompany = $('#grid_documents_company');

	if (!$gridHome.length && !$gridCompany.length) return;

    const $filter_type = $('#type_document');
    let $type;
    
    if( $('#documents_home').length ){
        $type = $filter_type.val();
        loadDocumentsHome( $type, 1);
    }

	/* R e s e a r c h  H o m e */
    // -- P a g i n a d o r -- //
    // Click en paginador (números)
    $(document).on('click', '.research-pagination p.page-number', function(e) {
		e.preventDefault();
		const paged = $(this).data('page');
		const type = $('#type_document').val();
		const searchQuery = $('#search_documents').val() || '';
		if (paged) loadDocumentsHome(type, paged, searchQuery);
	});
    // Botón anterior / siguiente
	$(document).on('click', '.prev_page_research, .next_page_research', function(e) {
		e.preventDefault();
		if ($(this).hasClass('disabled')) return;
		const paged = $(this).data('page');
		const type = $('#type_document').val();
		const searchQuery = $('#search_documents').val() || '';
		if (paged) loadDocumentsHome(type, paged, searchQuery);
	});
    // -- T i p o  D o c u m e n t o -- //
    $('#type_document.select_home').on('change', function() {
		const slug = $(this).val();
		const searchQuery = $('#search_documents').val() || '';
		loadDocumentsHome(slug, 1, searchQuery);
	});
    // -- B ú s q u e d a --//
	const doSearch = debounce(function(){
		const searchQuery = $('#search_documents').val() || '';
		const type = $('#type_document').val();
		loadDocumentsHome(type, 1, searchQuery);
	});
	$('#search_documents').on('keyup', function() {
		const v = $(this).val();
		if (v.length > 0 && v.length < 3) return;
		doSearch();
	});

	$('#search_documents').on('search', function() {
		doSearch();
	});

	/* E m p r e s a  S i n g l e */
	if ($('#grid_documents_company').length) {
		const companyId = parseInt($('#post_id').val(), 10) || 0;

		// primer load
		if (companyId) {
			loadDocumentsCompany(companyId, 1, 'all', '');
		}
	}
	// -- P a g i n a d o r -- //
    // Click en paginador 
	$(document).on('click', '.page-number-company, .prev_page_company, .next_page_company', function(e){
		e.preventDefault();
		if ($(this).hasClass('disabled')) return;

		const paged = parseInt($(this).data('page'), 10);
		if (!paged || paged < 1) return;

		const companyId = parseInt($('#post_id').val(), 10) || 0;
		const type = $('#type_document_company').val() || 'all';
		const q = $('#search_documents_company').val() || '';

		loadDocumentsCompany(companyId, paged, type, q);
	});
	// -- T i p o  D o c u m e n t o -- //
	$(document).on('change', '#type_document_company', function () {
		const companyId = parseInt($('#post_id').val(), 10) || 0;
		const type = ($(this).val() || 'all');
		const q = $('#search_documents_company').val() || '';
		loadDocumentsCompany(companyId, 1, type, q);
	});
	// -- B ú s q u e d a --//
	// Search company
	const doCompanySearch = debounce(function () {
		const companyId = parseInt($('#post_id').val(), 10) || 0;
		const type = ($('#type_document_company').val() || 'all');
		const q = $('#search_documents_company').val() || '';
		loadDocumentsCompany(companyId, 1, type, q);
	}, 250);

	$('#search_documents_company').on('keyup', function () {
		const v = $(this).val();
		if (v.length > 0 && v.length < 3) return;
		doCompanySearch();
	});

	$('#search_documents_company').on('search', function () {
		doCompanySearch();
	});

	$('#search_research_form_company').on('submit', function (e) {
		e.preventDefault();
		doCompanySearch();
	});

	/* G e n e r a l e s */
    if($('.btn_pop_pdf').length){
        viewerPDF();
    }
	$('#search_research_form').on('submit', function (e) { e.preventDefault(); });
  	$('#search_research_form_company').on('submit', function (e) { e.preventDefault(); });
});

// H O M E  R e s e a r c h
// Load documents

function loadDocumentsHome($type=null, $page=1, searchQuery=''){
	$.ajax({
		type:'POST',
		dataType:'html',
		url: cltvo_js_vars.ajax_url,
		data:{
		action: 'load_documents_home',
		type: $type,
		paged: $page,
		search_query: searchQuery
		},
		success: function(data){
		$('#grid_documents_research').html(data);

		if (!firstHomeLoad) {
			$('html, body').animate({ scrollTop: $('#container_documents_research').offset().top - 50 }, 300);
		}
		firstHomeLoad = false;

		renderPDFThumbnail();
		viewerPDF();
		}
	});
}

// S I N G L E  E m p r e s a s
function loadDocumentsCompany(companyId, paged = 1, type = 'all', searchQuery = '') {


	console.log('RESEARCH FILTERS JS VERSION 2026-02-17 17:34');
  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: cltvo_js_vars.ajax_url,
    data: {
      action: 'load_documents_research_company',
      company_id: companyId,
      paged,
      type_document: type,
      search_query: searchQuery
    },
    success: function (res) {
		console.log(res);
      $('#grid_documents_company').html(res.html);

      // llenar select solo cuando venga (page 1)
      if (res.types_html) {
        $('#type_document_company').html(res.types_html);

        // asegurar que el valor actual quede seleccionado
        $('#type_document_company').val(type);
      }

      if (!firstCompanyLoad) {
        $('html, body').animate({ scrollTop: $('#container_documents_research').offset().top - 50 }, 300);
      }
      firstCompanyLoad = false;

      renderPDFThumbnail();
      viewerPDF();
    },
    error: function (err) {
      console.log('loadDocumentsCompany error', err);
    }
  });
}

// Helpers
function debounce(fn, wait){
  let t; return function(){ clearTimeout(t); t = setTimeout(() => fn.apply(this, arguments), wait); };
}